import React, { Fragment, useEffect, useState } from "react";
import CommonCard from "../../common/components/CommonCard";
import { Box, Divider, Grid, Link, Switch, Typography } from "@mui/material";
import theme from "../../theme";
import CommonButton from "../../common/components/CommonButton";
import BarChart from "../Dcp Tutoring/BarChart";
import CommonFeatureIcon from "../../common/components/CommonFeatureIcon";
import { ExamTypes, PerforamcenExamType, Semesters, ServiceTypes, TimeBlocks, TopUpServices } from "../../common/const";
import LineChart from "../Dcp Tutoring/LineChart";
import { useDispatch } from "react-redux";
import { setLoading } from "../../features/authSlice";
import { getAcademicAnalytics } from "../../api/studentPerformanceApi";
import { showNotification } from "../../common/components/Notification/ToastifyNotification";
import CommonDialog from "../../common/components/CommonDialog";
import { Close } from "@mui/icons-material";
import moment from "moment";

const Semester = {
    One: 'Semester 1',
    Two: 'Semester 2'
};

const ApTutoring = () => {
    const [tutoringType, setTutoringType] = useState(PerforamcenExamType.AP);
    const [semester, setSemester] = useState(Semester.One);
    const [chartType, setChartType] = useState(true);
    const dispatch = useDispatch();
    const [data, setData] = useState(null);
    const [addSession, setAddSession] = useState(false);
    const [successOpen, setSuccess] = useState(false);
    const [selectedService, setSelectedServices] = useState(TopUpServices[0].label);
    const [timing, selectTiming] = useState(TimeBlocks[0].value);
    const [examType, setExamType] = useState(ExamTypes.APEXAM);

    const getExamData = async () => {
        try {
            dispatch(setLoading({
                loading: true
            }));
            const response = await getAcademicAnalytics(ServiceTypes[tutoringType], Semesters?.[semester], '');
            setData(response.data);
            dispatch(setLoading({
                loading: false
            }));
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({
                loading: false
            }));
        }
    }

    useEffect(() => {
        getExamData();
    }, [tutoringType, semester]);

    return (
        <Fragment>
            <CommonDialog
                open={successOpen}
                size="xs"
                title={
                    <Fragment>
                        <Close
                            sx={{
                                color: theme.palette.background.dark, fontSize: 20,
                                float: 'right',
                                cursor: 'pointer'
                            }}
                            onClick={() => {
                                setSuccess(false);
                                setAddSession(true);
                            }}
                        />
                    </Fragment>
                }
                content={(
                    <center>
                        <img
                            src='/Images/success.png'
                            alt='Check Circle'
                            style={{ width: '70px', height: '70px', marginTop: 20 }}
                        />
                        <Typography sx={{ fontWeight: 600, fontSize: '22px', mt: 0.5 }}>
                            Hours Added Successfully
                        </Typography>
                        <Typography variant="body2" color="text.secondary" paragraph mt={0.3}>
                            You have added {TimeBlocks.find((a) => a.value === timing)?.time}s to your project Mentoring Balance
                        </Typography>
                        <CommonCard
                            paddingBottom="0px"
                            borderRadius={2}
                            background="#FAFAFA"
                            content={
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Box display="flex" justifyContent="space-between">
                                            <Typography fontWeight={600}>Available Sessions</Typography>
                                            <Typography fontWeight={600} color="#10AE2D">+ {TimeBlocks.find((a) => a.value === timing)?.time}s</Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <CommonCard
                                            paddingBottom="0px"
                                            padding="10px 10px 5px 10px"
                                            borderRadius={2}
                                            marginTop="0px"
                                            content={
                                                <Box textAlign="left">
                                                    <Typography fontWeight={600}>02</Typography>
                                                    <Typography color="background.dark">Previous</Typography>
                                                </Box>
                                            }
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <CommonCard
                                            paddingBottom="0px"
                                            padding="10px 10px 5px 10px"
                                            borderRadius={2}
                                            marginTop="0px"
                                            content={
                                                <Box textAlign="left">
                                                    <Typography fontWeight={600}>{Number(TimeBlocks.find((a) => a.value === timing)?.time?.split(' ')?.[0]) + 2} Hours</Typography>
                                                    <Typography color="background.dark">Updated</Typography>
                                                </Box>
                                            }
                                        />
                                    </Grid>
                                </Grid>
                            }
                        />
                    </center>
                )}
                actionButtons={(
                    <CommonButton
                        label="Return To Dashboard"
                        size="small"
                        marginBottom="10px"
                        handleClick={() => {
                            setSuccess(false);
                            setAddSession(false);
                            setSelectedServices(TopUpServices[0].label);
                            selectTiming(TimeBlocks[0].value);
                        }}
                    />
                )}
            />
            <CommonDialog
                open={addSession}
                size="md"
                title={
                    <Fragment>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Typography sx={{ fontWeight: 600, fontSize: 18 }}>Top up Your Session</Typography>
                            <Close
                                sx={{
                                    color: theme.palette.background.dark, fontSize: 20,
                                    float: 'right',
                                    cursor: 'pointer'
                                }}
                                onClick={() => {
                                    setAddSession(false);
                                    setSelectedServices(TopUpServices[0].label);
                                    selectTiming(TimeBlocks[0].value);
                                }}
                            />
                        </Box>
                        <Box width="80%" mb={1}>
                            <Typography sx={{ fontSize: 12 }} color={theme.palette.background.dark}>Purchase additional hours for your plan</Typography>
                        </Box>
                        <Divider />
                    </Fragment>
                }
                content={
                    <Grid container spacing={1} mt={0.1}>
                        <Grid item md={12}>
                            <Typography fontWeight={600}>Which service do you need more time for?</Typography>
                        </Grid>
                        {(examType ? TopUpServices.filter((i) => i.examType === examType || i?.examType?.includes(examType)) : TopUpServices).map((a, index) => (
                            <Grid item xs={examType ? 12 : 2.4} key={index} onClick={() => setSelectedServices(a.label)}>
                                <CommonCard
                                    paddingBottom="0px"
                                    borderRadius={2}
                                    marginTop="0px"
                                    height="100px"
                                    border={!examType && `3px solid ${selectedService === a.label ? a.color === 'white' ? theme.palette.primary.main : a.color : '#000001A'}`}
                                    background={a.background}
                                    content={
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                height: '100%',           // Take full height of parent
                                                width: '100%',            // Take full width of parent
                                                flexDirection: 'column',
                                                textAlign: 'center'
                                            }}
                                        >
                                            <img src={a.image} alt="icon" />
                                            <Typography mt={0.5} fontSize={14} color={a.color}>
                                                {a.label}
                                            </Typography>
                                        </Box>
                                    }
                                />
                            </Grid>
                        ))}
                        <Grid item md={12}>
                            <Typography fontWeight={600}>Choose a Time Block</Typography>
                        </Grid>
                        {TimeBlocks.map((a, index) => (
                            <Grid item xs={3} key={index} onClick={() => selectTiming(a.value)}>
                                {a.popular ? (
                                    <Box
                                        sx={{
                                            position: 'relative',
                                            height: 'fit-content'
                                        }}
                                    >
                                        <CommonCard
                                            paddingBottom="0px"
                                            borderRadius={2}
                                            marginTop="0px"
                                            background={timing === a.value ? theme.palette.secondary.main : '#FFEECF'}
                                            content={
                                                <Box display="flex" alignItems="center" flexDirection="column" justifyContent="center">
                                                    <Typography fontSize={15} textAlign="center" fontWeight={600} color={timing === a.value ? 'white' : 'black'}>{a.time}</Typography>
                                                    <Typography fontSize={17} textAlign="center" fontWeight={600} color={timing === a.value ? 'white' : theme.palette.primary.main}>{a.value}</Typography>
                                                    <Typography fontSize={14} textAlign="center" color={timing === a.value ? 'white' : theme.palette.background.dark}>{a.label}</Typography>
                                                </Box>
                                            }
                                        />
                                        <Box
                                            sx={{
                                                position: 'absolute',
                                                top: '-9px',
                                                right: '65px',
                                                backgroundColor: '#D08700',
                                                color: 'white',
                                                padding: '2px 10px',
                                                borderRadius: '12px',
                                                fontSize: '10px',
                                                zIndex: 10
                                            }}
                                        >
                                            Most Popular
                                        </Box>
                                    </Box>
                                ) : (
                                    <CommonCard
                                        paddingBottom="0px"
                                        borderRadius={2}
                                        marginTop="0px"
                                        background={timing === a.value ? theme.palette.secondary.main : '#FFEECF'}
                                        content={
                                            <Box display="flex" alignItems="center" flexDirection="column" justifyContent="center">
                                                <Typography fontSize={15} textAlign="center" fontWeight={600} color={timing === a.value ? 'white' : 'black'}>{a.time}</Typography>
                                                <Typography fontSize={17} textAlign="center" fontWeight={600} color={timing === a.value ? 'white' : theme.palette.primary.main}>{a.value}</Typography>
                                                <Typography fontSize={14} textAlign="center" color={timing === a.value ? 'white' : theme.palette.background.dark}>{a.label}</Typography>
                                            </Box>
                                        }
                                    />
                                )}
                            </Grid>
                        ))}
                    </Grid>
                }
                actionButtons={(
                    <Box display="flex" justifyContent="space-between" width="100%" mt={2}>
                        <Box>
                            <Typography fontWeight={600}>{selectedService}</Typography>
                            <Box display="flex" gap={1}>
                                <Typography color={theme.palette.background.dark}>{TimeBlocks.find((a) => a.value === timing)?.time} - </Typography>
                                <Typography color={theme.palette.secondary.main} fontWeight={600}>{timing}</Typography>
                            </Box>
                        </Box>
                        <CommonButton
                            label="Proceed To Payment"
                            size="small"
                            background={theme.palette.secondary.main}
                            color={theme.palette.background.main}
                            fontWeight={700}
                            marginBottom="10px"
                            width="180px"
                            handleClick={() => {
                                setSuccess(true);
                            }}
                        />
                    </Box>
                )}
            />
            <CommonCard
                borderRadius={2}
                headerContent={
                    <Fragment>
                        <Grid container spacing={2} mb={1} p={2}>
                            <Grid item md={6}>
                                <Box
                                >
                                    <Box display="flex" gap={1}>
                                        <CommonButton
                                            label={PerforamcenExamType.AP}
                                            width="120px"
                                            fontWeight={600}
                                            color={tutoringType === PerforamcenExamType.AP ? theme.palette.secondary.main : theme.palette.background.dark}
                                            background={tutoringType === PerforamcenExamType.AP ? theme.palette.primary.main : '#FAFAFA'}
                                            handleClick={() => {
                                                setTutoringType(PerforamcenExamType.AP);
                                                setExamType(ExamTypes.APEXAM);
                                            }}
                                            marginBottom="0px"
                                        />
                                        <CommonButton
                                            label={PerforamcenExamType.ACADEMIC}
                                            width="160px"
                                            fontWeight={600}
                                            color={tutoringType === PerforamcenExamType.ACADEMIC ? theme.palette.secondary.main : theme.palette.background.dark}
                                            background={tutoringType === PerforamcenExamType.ACADEMIC ? theme.palette.primary.main : '#FAFAFA'}
                                            handleClick={() => {
                                                setTutoringType(PerforamcenExamType.ACADEMIC);
                                                setExamType(ExamTypes.ACADEMIC);
                                            }}
                                            marginBottom="0px"
                                        />
                                    </Box>
                                    <Typography fontWeight={600} mt={2}>{tutoringType} Insights</Typography>
                                    <Typography fontSize={14} color={theme.palette.background.dark}>Quick insights from AP Exams</Typography>
                                </Box>
                            </Grid>
                            <Grid item md={6}>
                                <CommonCard
                                    borderRadius={2}
                                    paddingBottom="0px"
                                    marginTop="0px"
                                    background={theme.palette.secondary.main}
                                    content={
                                        <Fragment>
                                            <Box display="flex" justifyContent="space-between" alignItems="center">
                                                <Box>
                                                    <Typography fontSize={15} color="white">Upcoming Test/Quiz/Assignment</Typography>
                                                    <Typography fontSize={18} fontWeight={600} color='#3FDFDF'>Next Test - {data?.next_exam?.find((a) => a.type === 'TEST')?.exam_date ? moment(data?.next_exam?.find((a) => a.type === 'TEST')?.exam_date)?.format('MMM DD') : ''}</Typography>
                                                    <Typography fontSize={18} fontWeight={600} color='#F815FC'>Next Quiz - {data?.next_exam?.find((a) => a.type === 'QUIZ')?.exam_date ? moment(data?.next_exam?.find((a) => a.type === 'QUIZ')?.exam_date)?.format('MMM DD') : ''}</Typography>
                                                    <Typography fontSize={18} fontWeight={600} color={theme.palette.primary.main}>Next Assignment - {data?.next_exam?.find((a) => a.type === 'ASSIGNMENT')?.exam_date ? moment(data?.next_exam?.find((a) => a.type === 'ASSIGNMENT')?.exam_date)?.format('MMM DD') : ''}</Typography>
                                                    <Typography fontSize={14} color="white">This is the right time to take {tutoringType === PerforamcenExamType.AP ? 'AP Tutor' : 'Academic Tutor'} service <Link sx={{ color: "white", textDecoration: 'none', borderBottom: '1px solid white' }} onClick={() => setAddSession(true)}>Add Session</Link></Typography>
                                                </Box>
                                                <CommonFeatureIcon icon={<img
                                                    src='/Images/Calendar.png'
                                                    style={{
                                                        width: 20,
                                                    }}
                                                    alt=''
                                                />}
                                                    background="white"
                                                    height="45px"
                                                    width="45px"
                                                />
                                            </Box>
                                        </Fragment>
                                    }
                                />
                            </Grid>
                        </Grid>
                    </Fragment>
                }
                content={
                    <Fragment>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Typography fontWeight={600}>{semester} Progress</Typography>
                            <Box display="flex" gap={2}>
                                <Box display="flex" gap={1}>
                                    <CommonButton
                                        label={Semester.One}
                                        width="120px"
                                        fontWeight={600}
                                        color={semester === Semester.One ? theme.palette.secondary.main : theme.palette.background.dark}
                                        background={semester === Semester.One ? theme.palette.primary.main : theme.palette.background.main}
                                        handleClick={() => setSemester(Semester.One)}
                                        marginBottom="0px"
                                        height="35px"
                                    />
                                    <CommonButton
                                        label={Semester.Two}
                                        width="120px"
                                        fontWeight={600}
                                        color={semester === Semester.Two ? theme.palette.secondary.main : theme.palette.background.dark}
                                        background={semester === Semester.Two ? theme.palette.primary.main : theme.palette.background.main}
                                        handleClick={() => setSemester(Semester.Two)}
                                        marginBottom="0px"
                                        height="35px"
                                    />
                                </Box>
                                <Box
                                    display="flex"
                                    gap={1}
                                    alignItems="center"
                                    sx={{
                                        background: '#FAFAFA',
                                        paddingLeft: 1,
                                        paddingRight: 1,
                                        borderRadius: 1
                                    }}
                                >
                                    <Typography fontSize={13}>Line Chart</Typography>
                                    <Switch
                                        size="Medium"
                                        checked={chartType}
                                        onChange={(e) => setChartType(e.target.checked)}
                                    />
                                    <Typography fontSize={13}>Bar Chart</Typography>
                                </Box>
                            </Box>
                        </Box>
                        {data?.history?.map((a) => a.month) && (
                            chartType === true ? (
                                <BarChart
                                    colors={[theme.palette.primary.main, '#F815FC', '#3FDFDF']}
                                    chartSeries={[
                                        {
                                            name: 'Assignments',
                                            data: data?.history?.map((a) => a.scores?.assignment_avg)
                                        },
                                        {
                                            name: 'Quizzes',
                                            data: data?.history?.map((a) => a.scores?.quiz_avg)
                                        },
                                        {
                                            name: 'Tests',
                                            data: data?.history?.map((a) => a.scores?.test_avg)
                                        }
                                    ]}
                                    categories={data?.history?.map((a) => a.month)}
                                    percentage
                                    width="20%"
                                />
                            ) : (
                                <LineChart
                                    colors={[theme.palette.primary.main, '#F815FC', '#3FDFDF']}
                                    chartSeries={[
                                        {
                                            name: 'Assignments',
                                            data: data?.history?.map((a) => a.scores?.assignment_avg)
                                        },
                                        {
                                            name: 'Quizzes',
                                            data: data?.history?.map((a) => a.scores?.quiz_avg)
                                        },
                                        {
                                            name: 'Tests',
                                            data: data?.history?.map((a) => a.scores?.test_avg)
                                        }
                                    ]}
                                    categories={data?.history?.map((a) => a.month)}
                                />
                            )
                        )}
                    </Fragment>
                }
                paddingBottom="0px"
                padding="13px"
                marginTop="15px"
            />
        </Fragment>
    )
}

export default ApTutoring